import { ConnectButton } from '@rainbow-me/rainbowkit'
import bg from './imgs/back.gif'
import fg from './imgs/land.jpg'

import dd from './imgs/DERP_TOKEN.png'
import React from 'react'
import Web3 from 'web3'

import {
	useAccount,
	useChainId,
    usePrepareTransactionRequest,
    useSendTransaction,
    useWaitForTransactionReceipt,
} from 'wagmi'

import { config } from './config'
import { fetchJsonWithFallback, imageCandidates } from './ipfs'
import { wearableCategories } from './wearables'
// import { whitelist } from './whitelist'


const web3 = new Web3(new Web3.providers.HttpProvider('https://rpc.soniclabs.com'));



export function Web3App (props) {
	const [cost, setCost] = React.useState(100)  
	const [pending, setIsPending] = React.useState(false)
	const [pendingText, setPendingText] = React.useState("Transaction is in process") 
	const { address, isConnected } = useAccount()
	const chainId  = useChainId()

	const networkConfig = config["mainnet"]

	
const [style, setStyle] = React.useState({backgroundImage: `url(${fg})`})

  React.useEffect(
  	() => {
  		
			if (isConnected) {
				setStyle({backgroundImage: `url(${bg})`})
			} else {
				setStyle({backgroundImage: `url(${fg})`})
			}
			
  			
  		
  	},
  	[isConnected]
  	)



	const derps = React.useMemo(
		() => new web3.eth.Contract(networkConfig["derps"]["abi"], networkConfig["derps"]["address"]),
		[networkConfig]
	)

	const [bal, setBal] = React.useState(0)
	const [ownedTokenIds, setOwnedTokenIds] = React.useState([])
	const [activeIndex, setActiveIndex] = React.useState(999)

	React.useEffect(() => {
		let cancelled = false

		const loadOwnedDerps = async () => {
			if (!isConnected || !address) {
				setBal(0)
				setOwnedTokenIds([])
				setActiveIndex(999)
				return
			}

			try {
				const balance = Number(await derps.methods.balanceOf(address).call({ from: address }))
				const tokenIds = await Promise.all(
					Array.from({ length: balance }, (_, index) => (
						derps.methods.tokenOfOwnerByIndex(address, index).call({ from: address })
					))
				)

				if (!cancelled) {
					setBal(balance)
					setOwnedTokenIds(tokenIds.map(String))
					setActiveIndex(balance > 0 ? 0 : 999)
				}
			} catch (error) {
				if (!cancelled) {
					console.error(`Unable to load Derps owned by ${address}`, error)
					setBal(0)
					setOwnedTokenIds([])
					setActiveIndex(999)
				}
			}
		}

		loadOwnedDerps()
		return () => { cancelled = true }
	}, [address, derps, isConnected])

	const next = () => {
		if (activeIndex < ownedTokenIds.length - 1 && activeIndex !== 999) {
			setActiveIndex((index) => index + 1)
		}
	}

	const prev = () => {
		if (activeIndex > 0 && activeIndex !== 999) {
			setActiveIndex((index) => index - 1)
		}
	}

	const activeID = activeIndex < ownedTokenIds.length ? ownedTokenIds[activeIndex] : 2001
	const [activeImages, setActiveImages] = React.useState([])
	const [activeImageIndex, setActiveImageIndex] = React.useState(0)
	const [metadataError, setMetadataError] = React.useState("")
	const [isDerpLoading, setIsDerpLoading] = React.useState(false)
	const legacyMetadataUri = `ipfs://bafybeigvx3vsvpjrakn6tc5xl7ylcv2mlm45kwupt3yagpr5ekro66pe4y/${activeID}.json`

	React.useEffect(() => {
		if (Number(activeID) >= 2001) return undefined

		const controller = new AbortController()

		const loadMetadata = async () => {
			setActiveImages([])
			setActiveImageIndex(0)
			setMetadataError("")
			setIsDerpLoading(true)

			try {
				let metadataUri = legacyMetadataUri

				try {
					metadataUri = await derps.methods.tokenURI(activeID).call()
				} catch (error) {
					console.warn(`tokenURI failed for Derp #${activeID}; using legacy metadata path`, error)
				}

				let metadata
				try {
					metadata = await fetchJsonWithFallback(metadataUri, { signal: controller.signal })
				} catch (error) {
					if (metadataUri === legacyMetadataUri || error.name === 'AbortError') throw error
					console.warn(`Contract metadata URI failed for Derp #${activeID}; using legacy metadata path`, error)
					metadata = await fetchJsonWithFallback(legacyMetadataUri, { signal: controller.signal })
				}
				const candidates = imageCandidates(metadata)

				if (!candidates.length) throw new Error('Metadata does not contain an image URI')
				setActiveImages(candidates)
			} catch (error) {
				if (error.name !== 'AbortError') {
					console.error(`Unable to load Derp #${activeID}`, error)
					setMetadataError('NFT image unavailable. Try again in a moment.')
					setIsDerpLoading(false)
				}
			}
		}

		loadMetadata()
		return () => controller.abort()
	}, [activeID, derps, legacyMetadataUri])

	const tryNextImageGateway = () => {
		setActiveImageIndex((index) => {
			if (index + 1 < activeImages.length) return index + 1
			setMetadataError('NFT image unavailable. Try again in a moment.')
			setIsDerpLoading(false)
			return activeImages.length
		})
	}

	const [openCategory, setOpenCategory] = React.useState(null)
	const [selectedWearables, setSelectedWearables] = React.useState([])

	const toggleCategory = (categoryId) => {
		setOpenCategory((current) => current === categoryId ? null : categoryId)
	}

	const toggleWearable = (wearable) => {
		setSelectedWearables((current) => current.some((item) => item.id === wearable.id)
			? current.filter((item) => item.id !== wearable.id)
			: [...current, wearable]
		)
	}

	const layeredWearables = [...selectedWearables].sort((first, second) => first.layer - second.layer)
	const activeCategory = wearableCategories.find((category) => category.id === openCategory)


  return (
	<div className={"App App--" + isConnected + " App-chain--" + chainId}>
	  	<div className="bg" style={style}>
	  		
	  		<div className="mint-box">
				<div className="derp-preview">
	  			<h2 className="derp-number">Derp #{activeID}</h2>
	  			<div className="mint-gif">
	  				{isDerpLoading && (
	  					<div className="derp-loader" role="status" aria-label={`Loading Derp #${activeID}`}>
	  						<span className="derp-pinwheel" />
	  					</div>
	  				)}
	  				{activeImages[activeImageIndex] && (
	  					<img
	  						className="nft-image"
	  						src={activeImages[activeImageIndex]}
	  						alt={`Derp #${activeID}`}
	  						onLoad={() => setIsDerpLoading(false)}
	  						onError={tryNextImageGateway}
	  					/>
	  				)}
	  				{metadataError && <p className="nft-load-error">{metadataError}</p>}
	  				{layeredWearables.map((wearable) => (
	  					<img
	  						className="wearable-layer"
	  						key={wearable.id}
	  						src={wearable.image}
	  						style={{ zIndex: wearable.layer }}
	  						alt=""
	  					/>
	  				))}
	  			</div>
	  			<div className="change-nft">
	  				<button onClick={prev}>back</button>
	  				<span>{activeIndex === 999 ? '0 of 0' : `${activeIndex + 1} of ${ownedTokenIds.length}`}</span>
	  				<button onClick={next}>next</button>
	  			</div>
				</div>
	  		</div>

			<div className="wardrobe-dock">
				{activeCategory && (
					<div className="wearable-tray">
						<div className="wardrobe-heading">
							<span>{activeCategory.name}</span>
							{selectedWearables.length > 0 && (
								<button type="button" onClick={() => setSelectedWearables([])}>Clear all</button>
							)}
						</div>
						<div className="wearable-items">
							{activeCategory.items.map((wearable) => {
								const isSelected = selectedWearables.some((item) => item.id === wearable.id)
								return (
									<button
										className={`wearable-button wearable-button--${isSelected ? 'selected' : 'idle'}`}
										key={wearable.id}
										type="button"
										onClick={() => toggleWearable(wearable)}
										aria-pressed={isSelected}
										title={wearable.name}
									>
										<img src={wearable.icon} alt="" />
										<span>{wearable.name}</span>
									</button>
								)
							})}
						</div>
					</div>
				)}
				<div className="category-dock" aria-label="Wardrobe categories">
					{wearableCategories.map((category) => {
						const isOpen = openCategory === category.id
						const selectedCount = selectedWearables.filter((item) => item.categoryId === category.id).length
						return (
							<button
								className={`category-tile category-tile--${isOpen ? 'open' : 'closed'}`}
								key={category.id}
								type="button"
								onClick={() => toggleCategory(category.id)}
								aria-expanded={isOpen}
								title={category.name}
							>
								<img src={category.icon} alt="" />
								<span>{category.name}</span>
								{selectedCount > 0 && <strong>{selectedCount}</strong>}
							</button>
						)
					})}
				</div>
			</div>
	  			
	  		
	  		<p className="bal">You have {bal} derps</p>
	  		
	  
	  		<div className="dd"><img src={dd}/></div>
	  		<div className="connect-button">
	  			<div className="inliner docs"><a href="https://docs.derpe.xyz" target="_blank">DOCS</a></div>
	  			<div className="inliner"><ConnectButton /></div>
	  		</div>

	  		
	  		{
	  			/*
	  			<div className="addys">whitelist.map((addy,i)=>(
	  				<p>{web3.utils.toChecksumAddress(addy)}</p>

	  				))

	  				</div>*/

	  		}

			

	  		
	  	</div>
	 
  	</div>
  	)
};
